var _path, _path2, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 40.5C30.5 41.6457 29.4516 43.1445 26.6771 44.4451C24.0221 45.6896 20.2488 46.5 16 46.5C11.7512 46.5 7.97793 45.6896 5.32294 44.4451C2.54839 43.1445 1.5 41.6457 1.5 40.5C1.5 39.3543 2.54839 37.8555 5.32294 36.5549C7.97793 35.3104 11.7512 34.5 16 34.5C20.2488 34.5 24.0221 35.3104 26.6771 36.5549C29.4516 37.8555 30.5 39.3543 30.5 40.5Z",
    stroke: "#152C5B",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 13.3953C28.5 16.8294 27.0031 23.6526 24.5142 29.6467C23.2754 32.6301 21.833 35.3025 20.2863 37.2018C18.7014 39.1481 17.2445 40 16 40C14.7555 40 13.2986 39.1481 11.7137 37.2018C10.167 35.3025 8.72465 32.6301 7.48583 29.6467C4.99689 23.6526 3.5 16.8294 3.5 13.3953C3.5 6.88745 9.03334 1.5 16 1.5C22.9667 1.5 28.5 6.88745 28.5 13.3953Z",
    fill: "white",
    stroke: "#152C5B",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 14,
    r: 4.5,
    stroke: "#FF498B",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCities);
export default __webpack_public_path__ + "static/media/icon-cities.3d4f2d9a801c8bf5978a587f2baa534f.svg";
export { ForwardRef as ReactComponent };